import { render, staticRenderFns } from "./BotContent.vue?vue&type=template&id=d2637222&scoped=true"
import script from "./BotContent.vue?vue&type=script&lang=js"
export * from "./BotContent.vue?vue&type=script&lang=js"
import style0 from "./BotContent.vue?vue&type=style&index=0&id=d2637222&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2637222",
  null
  
)

export default component.exports